module.exports = __webpack_public_path__ + "img/deb-cred.56ca1a8a.svg";